module.exports = __webpack_public_path__ + "static/media/transaction.2a2c6596.svg";